(function () {
    function formatMoney(cents, moneyFormat) {
        // Simple formatter for Shopify money formats.
        // Handles the common {{amount}} placeholder.
        const amount = (cents / 100).toFixed(2);
        return moneyFormat.replace("{{amount}}", amount);
    }

    function getSelectedVariantId(sectionId) {
        // Look for the variant ID input in the product form
        const input = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
        return input ? Number(input.value) : null;
    }

    function updateTotal(sectionId) {
        const totalEl = document.getElementById(`SponsorshipTotal-${sectionId}`);
        if (!totalEl) return;

        const variantsJsonEl = document.getElementById(`SponsorshipVariants-${sectionId}`);
        if (!variantsJsonEl) return;

        const variants = JSON.parse(variantsJsonEl.textContent || "[]");
        const variantId = getSelectedVariantId(sectionId);
        const variant = variants.find(v => v.id === variantId);
        if (!variant) return;

        const qtyInput = document.getElementById(`Quantity-${sectionId}`);
        const qty = qtyInput ? Math.max(1, Number(qtyInput.value || 1)) : 1;
        const totalCents = variant.price * qty; // Shopify variant.price is in cents
        const moneyFormat = totalEl.getAttribute("data-money-format") || "{{amount}}";

        totalEl.textContent = formatMoney(totalCents, moneyFormat);
    }

    function init() {
        document.querySelectorAll('[id^="SponsorshipTotal-"]').forEach((el) => {
            const sectionId = el.getAttribute("data-section-id");
            if (!sectionId) return;

            // initial render
            updateTotal(sectionId);

            // quantity changes
            const qtyInput = document.getElementById(`Quantity-${sectionId}`);
            if (qtyInput) {
                qtyInput.addEventListener("input", () => updateTotal(sectionId));
                qtyInput.addEventListener("change", () => updateTotal(sectionId));
            }

            // variant changes (variant-selects and variant-radios dispatch 'change' events on themselves)
            const variantSelects = document.querySelector(`variant-selects[data-section="${sectionId}"]`);
            const variantRadios = document.querySelector(`variant-radios[data-section="${sectionId}"]`);

            if (variantSelects) {
                variantSelects.addEventListener("change", () => updateTotal(sectionId));
            }
            if (variantRadios) {
                variantRadios.addEventListener("change", () => updateTotal(sectionId));
            }

            // also update after any form change inside the product form
            const form = document.getElementById(`product-form-${sectionId}`);
            if (form) {
                form.addEventListener("change", () => updateTotal(sectionId));
            }
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
